import React, {Component} from 'react';
import './subscription-list.css';

/**
 * @property data {array} data sources.
 * [{label: 'Info', value: 12322}]
 * @property hiddenMiddleBorder {boolean} if hidden middle border
 */
class SubscriptionList extends Component {
  render () {
    return (
      <ul className={`subscription-list clearfix ${this.props.hiddenMiddleBorder && 'hidden-border'}`}>
        {
          Array.isArray(this.props.data) && this.props.data.map((item, index) => (
            <li className="clearfix" key={index}>
              <strong className="pull-left">{item.label}</strong>
              <span className="pull-right">{item.value}</span>
            </li>
          ))
        }
      </ul>
    )
  }
}

export default SubscriptionList;


// WEBPACK FOOTER //
// ./src/components/SubscriptionsInfo/List/SubscriptionList.jsx